<template>
  <div ref="chart" class="chart" :style="{ height: height, ...chartStyle }">雷达图</div>
</template>

<script>
import { echartBaseMixin, radarMixin } from '../mixins'

export default {
  name: 'RadarChart',
  mixins: [echartBaseMixin, radarMixin], // 混合
  props: {
    type: {
      type: String,
      default: 'radar',
    },
    indicator: {
      type: Array,
      default: () => [],
    },
    radius: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      options: {
        // title: {
        //   text: 'Basic Radar Chart',
        // },
        legend: {
          // data: ['Allocated Budget', 'Actual Spending'],
          data: [],
        },
        radar: {
          // shape: 'circle',
          indicator: [
            // { name: 'Sales', max: 6500 },
            // { name: 'Administration', max: 16000 },
            // { name: 'Information Technology', max: 30000 },
            // { name: 'Customer Support', max: 38000 },
            // { name: 'Development', max: 52000 },
            // { name: 'Marketing', max: 25000 },
          ],
        },
        series: [
          {
            type: 'radar',
            tooltip: {
              trigger: 'item',
            },
            // areaStyle: {},
            data: [
              // {
              //   value: [4200, 3000, 20000, 35000, 50000, 18000],
              //   name: 'Allocated Budget',
              // },
              // {
              //   value: [5000, 14000, 28000, 26000, 42000, 21000],
              //   name: 'Actual Spending',
              // },
            ],
          },
        ],
      },
    }
  },
  watch: {
    dataSource: {
      handler(val) {
        this.initRadarOptions()
        this.initOptionConfig()
        this.setLegend()
        this.renderChart()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initOptionConfig() {
      this.options = {
        ...this.options,
        grid: this.grid,
        toolbox: this.toolbox,
        ...this.attrs,
        tooltip: {
          trigger: 'axis',
          position: 'left',
          ...this.tooltip,
        },
      }
    },
    initRadarOptions() {
      this.$set(this.options.radar, 'indicator', this.indicator)
      this.$set(this.options.radar, 'radius', this.radius)
      this.$set(this.options.series[0], 'data', this.dataSource)
    },
  },
}
</script>
<style lang="less" scoped>
.chart {
  width: 100%;
}
</style>
